﻿/* eslint-disable no-console */
import { Widget } from "blue-widgets";

class Discount extends Widget {
    constructor(el) {
        super(el);

        if (!this.el) return;

        this.discountButton = this.el.querySelector(".js-discount-button");
        this.inputFieldWrapper = this.el.querySelector(".js-input-field-wrapper");
        this.discountErrorMessage = this.el.querySelector(".js-discount-error-message");
        this.codeInput = this.el.querySelector("input[name=\"code\"]");

        this.discountButton.addEventListener("click", this.addDiscount);
    }

    addDiscount = async (event) => {
        console.log(event);
        event.preventDefault(); // Prevent the default form submission

        if (!this.codeInput.value) return;

        await fetch("/umbraco/Surface/CheckoutSurface/ApplyDiscountOrGiftCardCode", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                code: this.codeInput.value,
            })
        })
            .then(async (response) => {
                if (response.ok) {
                    this.inputFieldWrapper.classList.remove("input-field--error");
                    this.inputFieldWrapper.classList.add("input-field--undefined");
                    this.discountErrorMessage.style.display = "none";
                    location.reload();
                } else {
                    this.inputFieldWrapper.classList.remove("input-field--undefined");
                    this.inputFieldWrapper.classList.add("input-field--error");
                    this.discountErrorMessage.style.display = "block";
                    console.error("Error sending POST request. Status:", response.status);
                }
            })
            .catch((error) => {
                this.inputFieldWrapper.classList.remove("input-field--undefined");
                this.inputFieldWrapper.classList.add("input-field--error");
                this.discountErrorMessage.style.display = "block";
                console.error("Error sending POST request:", error);
            });
    };

    removeDiscount = async () => {

    };
}

export default Discount;